/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import * as storeEffects from "../../models/store/storeEffects";
import { IApplicationState } from "../../models/store/storeTypes";
import { IWhistleBlowPageOwnProps, IWhistleBlowPageStateProps, IWhistleBlowPageDispatchProps, WhistleBlowPage } from "../../components/whistleBlow/WhistleBlowPage/WhistleBlowPage";
import { ITypedOption } from "../../models/common/typedOption";
import { getWhistleBlowPage, WhistleBlowThunkDispatch } from "source/models/store/whistleBlow";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IWhistleBlowPageOwnProps): IWhistleBlowPageStateProps {
    if (!applicationState || !applicationState.whistleBlow) {
        return {
            appState: null,
            dataId: -1,
            whistleBlowPage: null,
            list: null
        };
    }
    const whistleBlow = applicationState.whistleBlow;
    return {
        appState: applicationState.session,
        dataId: whistleBlow.page.dataId,
        whistleBlowPage: whistleBlow.page.whistleBlowPage,
        list: whistleBlow.list
    };
}

export function mapDispatchToProps(dispatch: WhistleBlowThunkDispatch): IWhistleBlowPageDispatchProps {
    return {
        onGetWhistleBlowPage: () => dispatch(getWhistleBlowPage()),
        onLogout: () => dispatch(storeEffects.logout()),
        onSetCulture: (culture: string) => dispatch(storeEffects.setCulture(culture)),
        onSaveUserParameters: (parameters: ITypedOption[]) => dispatch(storeEffects.saveUserParameters(parameters)),
        onRefreshSessionState: () => dispatch(storeEffects.refreshSessionState()),
    };
}

export default connect<IWhistleBlowPageStateProps, IWhistleBlowPageDispatchProps, IWhistleBlowPageOwnProps>(mapStateToProps, mapDispatchToProps)(WhistleBlowPage);